module.exports = __webpack_public_path__ + "assets/images/project/close.svg?v=dfda2ea9";